import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('complex-table', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('complex-table');

      return new ViewModel(params, element);
    },
  },
  template: html,
});
